import React, { useContext, useState } from "react"
import { Col, Row } from "react-bootstrap"
import { Link } from "gatsby"

import "./job-card.scss"
import DefaultPic from "../../images/logo.svg"
import JobCardButtons from "./job-card-buttons"
import ModalComponent from "../modal/modal"
import DeleteConfirmForm from "../candidate-profile/form/delete-confirm"
import { GlobalAuthContext } from "../../context/authContext"

const JobCard = ({ job_data }) => {
  const { state, dispatch } = useContext(GlobalAuthContext)
  const [show, setShow] = useState(false)

  const handleDeletedLogic = data => {
    dispatch({
      type: "COMPANY_JOB_POSTED",
      payload: data,
    })
  }
  return (
    <div className="job-card p-4 p-lg-2 border rounded">
      <ModalComponent show={show} setShow={setShow}>
        <DeleteConfirmForm
          type="JOB_POST"
          setShowDeleteForm={setShow}
          id={job_data?.id}
          setData={handleDeletedLogic}
          isCompany
          data={job_data}
        />
      </ModalComponent>
      <Row className="align-items-center">
        <Col md="8">
          <div className="job-image-title">
            <Row className="justify-content-center justify-content-md-start">
              <Link to={`/jobs/${job_data?.id}`}>
                <Col md="3">
                  <img
                    src={job_data?.company?.avatar ?? DefaultPic}
                    alt=""
                    height="80px"
                    width="80px"
                    className=" border"
                  />
                </Col>
              </Link>

              <Col md="9">
                <div className="name-info-desc">
                  <Link to={`/jobs/${job_data?.id}`}>
                    <h3 className="mb-2">
                      {job_data?.title}{" "}
                      <span className="blue-text">: {job_data?.job_type}</span>
                    </h3>
                    {job_data?.company?.organization_name ? (
                      <p className="mb-4">
                        {job_data?.company?.organization_name}
                      </p>
                    ) : (
                      ""
                    )}
                    {!state?.user?.company?.id &&
                    job_data?.country &&
                    job_data?.district ? (
                      <p className="mb-2 mb-lg-0">{`${job_data?.district}, ${job_data?.country}`}</p>
                    ) : (
                      ""
                    )}
                  </Link>
                  {state?.user?.company?.id ? (
                    <div className="mb-2 mb-md-0 d-flex justify-content-center justify-content-md-start">
                      {job_data?.applicants > 0 ? (
                        <Link
                          to={`/jobs/${job_data?.id}/applicants`}
                          className="blue-text"
                        >
                          Applicants: {job_data?.applicants}
                        </Link>
                      ) : (
                        <div>Applicants: {job_data?.applicants ?? 0}</div>
                      )}
                      <span className="mx-2">|</span>
                      {job_data?.shortlisted > 0 ? (
                        <Link
                          to={`/jobs/${job_data?.id}/shortlist`}
                          className="blue-text"
                        >
                          Shortlisted: {job_data?.shortlisted}
                        </Link>
                      ) : (
                        <div>Shortlisted: {job_data?.shortlisted ?? 0}</div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </Col>
        <Col md="4 ">
          <JobCardButtons show={show} setShow={setShow} data={job_data} />
        </Col>
      </Row>
    </div>
  )
}

export default JobCard
